/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Sub_Processors_TitleInputs */

const en_privacy_sub_processors_title = /** @type {(inputs: Privacy_Sub_Processors_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Sub-Processors`)
};

const de_privacy_sub_processors_title = /** @type {(inputs: Privacy_Sub_Processors_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Auftragsverarbeiter`)
};

const fr_privacy_sub_processors_title = /** @type {(inputs: Privacy_Sub_Processors_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Sous-traitants`)
};

const es_privacy_sub_processors_title = /** @type {(inputs: Privacy_Sub_Processors_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Subencargados`)
};

const it_privacy_sub_processors_title = /** @type {(inputs: Privacy_Sub_Processors_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Sub-responsabili del trattamento`)
};

const nl_privacy_sub_processors_title = /** @type {(inputs: Privacy_Sub_Processors_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Subverwerkers`)
};

const pl_privacy_sub_processors_title = /** @type {(inputs: Privacy_Sub_Processors_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Podwykonawcy przetwarzania`)
};

const fi_privacy_sub_processors_title = /** @type {(inputs: Privacy_Sub_Processors_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Alikäsittelijät`)
};

const da_privacy_sub_processors_title = /** @type {(inputs: Privacy_Sub_Processors_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Underdatabehandlere`)
};

const sv_privacy_sub_processors_title = /** @type {(inputs: Privacy_Sub_Processors_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Underbiträden`)
};

/**
* | output |
* | --- |
* | "3. Sub-Processors" |
*
* @param {Privacy_Sub_Processors_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const privacy_sub_processors_title = /** @type {((inputs?: Privacy_Sub_Processors_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Sub_Processors_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_privacy_sub_processors_title(inputs)
	if (locale === "fr") return fr_privacy_sub_processors_title(inputs)
	if (locale === "es") return es_privacy_sub_processors_title(inputs)
	if (locale === "it") return it_privacy_sub_processors_title(inputs)
	if (locale === "nl") return nl_privacy_sub_processors_title(inputs)
	if (locale === "pl") return pl_privacy_sub_processors_title(inputs)
	if (locale === "fi") return fi_privacy_sub_processors_title(inputs)
	if (locale === "da") return da_privacy_sub_processors_title(inputs)
	if (locale === "sv") return sv_privacy_sub_processors_title(inputs)
	return en_privacy_sub_processors_title(inputs)
});